module.exports = __webpack_public_path__ + "img/table-filter.d305a0f0.svg";